import React, { useState } from 'react';
import { Box, CardActionArea, Typography, Tooltip } from '@mui/material';
import InfoKnowledgeDialog from './InfoKnowledge';
import './box.scss';

interface PriorityBoxProps {
  index?: number;
  label: string;
  hasPadding?: boolean;
  fullWidth?: boolean;
  icon?: any;
  onClick?: () => void;
}
const PriorityBox: React.FC<PriorityBoxProps> = (props) => {
  const { index, label, hasPadding, fullWidth, icon, onClick } = props;
  const [openInfoKnowledgeDialog, setOpenInfoKnowledgeDialog] = useState(false);

  return (
    <>
      <CardActionArea
        className='cardActionArea'
        onClick={() => (onClick ? onClick() : !index && setOpenInfoKnowledgeDialog(true))}
        sx={{ width: fullWidth ? '100%' : 'fit-content' }}
      >
        <Box className='priorityBox' sx={{ width: fullWidth ? '100%' : 'fit-content' }}>
          {index && (
            <Box bgcolor='primary.main' className='badge'>
              <Typography color='white'>{index}</Typography>
            </Box>
          )}

          {icon && icon && <img src={icon} alt='' />}

          <Tooltip title={label.trim().length > 20 ? label : ''} placement='top'>
            <Box
              bgcolor='background.footer'
              className='inlineBox'
              sx={{
                padding: hasPadding ? '0.3rem 1.5rem' : '0.3rem',
                width: fullWidth ? '100%' : 'fit-content',
              }}
            >
              <Typography color='text.main' noWrap>
                {label}
              </Typography>
            </Box>
          </Tooltip>
        </Box>
      </CardActionArea>

      <InfoKnowledgeDialog
        openInfoKnowledgeDialog={openInfoKnowledgeDialog}
        closeDialog={() => setOpenInfoKnowledgeDialog(false)}
        label={label}
      />
    </>
  );
};

export default PriorityBox;
